import React from 'react';

import SettingsPageContent
  from 'components/dashboard/settings-content/SettingsPageContent';

const DashboardSettingsPage = () => <SettingsPageContent />;

export default DashboardSettingsPage;
